/**
 * Comprehensive country data for nationality/residency selection
 * Includes all UN member states and common territories
 */

export interface Country {
  value: string;
  label: string;
  flag: string;
  code: string;
  dialCode: string;
}

export const COUNTRIES: Country[] = [
  // Major Western Countries
  { value: "United States", label: "United States", flag: "🇺🇸", code: "US", dialCode: "+1" },
  { value: "United Kingdom", label: "United Kingdom", flag: "🇬🇧", code: "GB", dialCode: "+44" },
  { value: "Canada", label: "Canada", flag: "🇨🇦", code: "CA", dialCode: "+1" },
  { value: "Australia", label: "Australia", flag: "🇦🇺", code: "AU", dialCode: "+61" },
  { value: "New Zealand", label: "New Zealand", flag: "🇳🇿", code: "NZ", dialCode: "+64" },
  
  // Western Europe
  { value: "France", label: "France", flag: "🇫🇷", code: "FR", dialCode: "+33" },
  { value: "Germany", label: "Germany", flag: "🇩🇪", code: "DE", dialCode: "+49" },
  { value: "Italy", label: "Italy", flag: "🇮🇹", code: "IT", dialCode: "+39" },
  { value: "Spain", label: "Spain", flag: "🇪🇸", code: "ES", dialCode: "+34" },
  { value: "Netherlands", label: "Netherlands", flag: "🇳🇱", code: "NL", dialCode: "+31" },
  { value: "Belgium", label: "Belgium", flag: "🇧🇪", code: "BE", dialCode: "+32" },
  { value: "Switzerland", label: "Switzerland", flag: "🇨🇭", code: "CH", dialCode: "+41" },
  { value: "Austria", label: "Austria", flag: "🇦🇹", code: "AT", dialCode: "+43" },
  { value: "Portugal", label: "Portugal", flag: "🇵🇹", code: "PT", dialCode: "+351" },
  { value: "Ireland", label: "Ireland", flag: "🇮🇪", code: "IE", dialCode: "+353" },
  { value: "Luxembourg", label: "Luxembourg", flag: "🇱🇺", code: "LU", dialCode: "+352" },
  { value: "Monaco", label: "Monaco", flag: "🇲🇨", code: "MC", dialCode: "+377" },
  { value: "Andorra", label: "Andorra", flag: "🇦🇩", code: "AD", dialCode: "+376" },
  { value: "San Marino", label: "San Marino", flag: "🇸🇲", code: "SM", dialCode: "+378" },
  { value: "Vatican City", label: "Vatican City", flag: "🇻🇦", code: "VA", dialCode: "+379" },
  { value: "Liechtenstein", label: "Liechtenstein", flag: "🇱🇮", code: "LI", dialCode: "+423" },
  
  // Nordic Countries
  { value: "Sweden", label: "Sweden", flag: "🇸🇪", code: "SE", dialCode: "+46" },
  { value: "Norway", label: "Norway", flag: "🇳🇴", code: "NO", dialCode: "+47" },
  { value: "Denmark", label: "Denmark", flag: "🇩🇰", code: "DK", dialCode: "+45" },
  { value: "Finland", label: "Finland", flag: "🇫🇮", code: "FI", dialCode: "+358" },
  { value: "Iceland", label: "Iceland", flag: "🇮🇸", code: "IS", dialCode: "+354" },
  
  // Eastern Europe
  { value: "Poland", label: "Poland", flag: "🇵🇱", code: "PL", dialCode: "+48" },
  { value: "Czech Republic", label: "Czech Republic", flag: "🇨🇿", code: "CZ", dialCode: "+420" },
  { value: "Hungary", label: "Hungary", flag: "🇭🇺", code: "HU", dialCode: "+36" },
  { value: "Romania", label: "Romania", flag: "🇷🇴", code: "RO", dialCode: "+40" },
  { value: "Bulgaria", label: "Bulgaria", flag: "🇧🇬", code: "BG", dialCode: "+359" },
  { value: "Croatia", label: "Croatia", flag: "🇭🇷", code: "HR", dialCode: "+385" },
  { value: "Slovenia", label: "Slovenia", flag: "🇸🇮", code: "SI", dialCode: "+386" },
  { value: "Slovakia", label: "Slovakia", flag: "🇸🇰", code: "SK", dialCode: "+421" },
  { value: "Estonia", label: "Estonia", flag: "🇪🇪", code: "EE", dialCode: "+372" },
  { value: "Latvia", label: "Latvia", flag: "🇱🇻", code: "LV", dialCode: "+371" },
  { value: "Lithuania", label: "Lithuania", flag: "🇱🇹", code: "LT", dialCode: "+370" },
  { value: "Ukraine", label: "Ukraine", flag: "🇺🇦", code: "UA", dialCode: "+380" },
  { value: "Belarus", label: "Belarus", flag: "🇧🇾", code: "BY", dialCode: "+375" },
  { value: "Moldova", label: "Moldova", flag: "🇲🇩", code: "MD", dialCode: "+373" },
  { value: "Serbia", label: "Serbia", flag: "🇷🇸", code: "RS", dialCode: "+381" },
  { value: "Montenegro", label: "Montenegro", flag: "🇲🇪", code: "ME", dialCode: "+382" },
  { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina", flag: "🇧🇦", code: "BA", dialCode: "+387" },
  { value: "North Macedonia", label: "North Macedonia", flag: "🇲🇰", code: "MK", dialCode: "+389" },
  { value: "Albania", label: "Albania", flag: "🇦🇱", code: "AL", dialCode: "+355" },
  { value: "Kosovo", label: "Kosovo", flag: "🇽🇰", code: "XK", dialCode: "+383" },
  
  // Southern Europe & Mediterranean
  { value: "Greece", label: "Greece", flag: "🇬🇷", code: "GR", dialCode: "+30" },
  { value: "Cyprus", label: "Cyprus", flag: "🇨🇾", code: "CY", dialCode: "+357" },
  { value: "Malta", label: "Malta", flag: "🇲🇹", code: "MT", dialCode: "+356" },
  
  // Russia & Former Soviet States
  { value: "Russia", label: "Russia", flag: "🇷🇺", code: "RU", dialCode: "+7" },
  { value: "Kazakhstan", label: "Kazakhstan", flag: "🇰🇿", code: "KZ", dialCode: "+7" },
  { value: "Uzbekistan", label: "Uzbekistan", flag: "🇺🇿", code: "UZ", dialCode: "+998" },
  { value: "Turkmenistan", label: "Turkmenistan", flag: "🇹🇲", code: "TM", dialCode: "+993" },
  { value: "Kyrgyzstan", label: "Kyrgyzstan", flag: "🇰🇬", code: "KG", dialCode: "+996" },
  { value: "Tajikistan", label: "Tajikistan", flag: "🇹🇯", code: "TJ", dialCode: "+992" },
  { value: "Armenia", label: "Armenia", flag: "🇦🇲", code: "AM", dialCode: "+374" },
  { value: "Georgia", label: "Georgia", flag: "🇬🇪", code: "GE", dialCode: "+995" },
  { value: "Azerbaijan", label: "Azerbaijan", flag: "🇦🇿", code: "AZ", dialCode: "+994" },
  
  // Middle East
  { value: "United Arab Emirates", label: "United Arab Emirates", flag: "🇦🇪", code: "AE", dialCode: "+971" },
  { value: "Saudi Arabia", label: "Saudi Arabia", flag: "🇸🇦", code: "SA", dialCode: "+966" },
  { value: "Qatar", label: "Qatar", flag: "🇶🇦", code: "QA", dialCode: "+974" },
  { value: "Kuwait", label: "Kuwait", flag: "🇰🇼", code: "KW", dialCode: "+965" },
  { value: "Bahrain", label: "Bahrain", flag: "🇧🇭", code: "BH", dialCode: "+973" },
  { value: "Oman", label: "Oman", flag: "🇴🇲", code: "OM", dialCode: "+968" },
  { value: "Israel", label: "Israel", flag: "🇮🇱", code: "IL", dialCode: "+972" },
  { value: "Palestine", label: "Palestine", flag: "🇵🇸", code: "PS", dialCode: "+970" },
  { value: "Lebanon", label: "Lebanon", flag: "🇱🇧", code: "LB", dialCode: "+961" },
  { value: "Jordan", label: "Jordan", flag: "🇯🇴", code: "JO", dialCode: "+962" },
  { value: "Syria", label: "Syria", flag: "🇸🇾", code: "SY", dialCode: "+963" },
  { value: "Iraq", label: "Iraq", flag: "🇮🇶", code: "IQ", dialCode: "+964" },
  { value: "Iran", label: "Iran", flag: "🇮🇷", code: "IR", dialCode: "+98" },
  { value: "Turkey", label: "Turkey", flag: "🇹🇷", code: "TR", dialCode: "+90" },
  { value: "Yemen", label: "Yemen", flag: "🇾🇪", code: "YE", dialCode: "+967" },
  
  // North Africa
  { value: "Egypt", label: "Egypt", flag: "🇪🇬", code: "EG", dialCode: "+20" },
  { value: "Morocco", label: "Morocco", flag: "🇲🇦", code: "MA", dialCode: "+212" },
  { value: "Algeria", label: "Algeria", flag: "🇩🇿", code: "DZ", dialCode: "+213" },
  { value: "Tunisia", label: "Tunisia", flag: "🇹🇳", code: "TN", dialCode: "+216" },
  { value: "Libya", label: "Libya", flag: "🇱🇾", code: "LY", dialCode: "+218" },
  { value: "Sudan", label: "Sudan", flag: "🇸🇩", code: "SD", dialCode: "+249" },
  { value: "South Sudan", label: "South Sudan", flag: "🇸🇸", code: "SS", dialCode: "+211" },
  
  // Sub-Saharan Africa
  { value: "South Africa", label: "South Africa", flag: "🇿🇦", code: "ZA", dialCode: "+27" },
  { value: "Nigeria", label: "Nigeria", flag: "🇳🇬", code: "NG", dialCode: "+234" },
  { value: "Kenya", label: "Kenya", flag: "🇰🇪", code: "KE", dialCode: "+254" },
  { value: "Ghana", label: "Ghana", flag: "🇬🇭", code: "GH", dialCode: "+233" },
  { value: "Ethiopia", label: "Ethiopia", flag: "🇪🇹", code: "ET", dialCode: "+251" },
  { value: "Tanzania", label: "Tanzania", flag: "🇹🇿", code: "TZ", dialCode: "+255" },
  { value: "Uganda", label: "Uganda", flag: "🇺🇬", code: "UG", dialCode: "+256" },
  { value: "Senegal", label: "Senegal", flag: "🇸🇳", code: "SN", dialCode: "+221" },
  { value: "Ivory Coast", label: "Ivory Coast", flag: "🇨🇮", code: "CI", dialCode: "+225" },
  { value: "Cameroon", label: "Cameroon", flag: "🇨🇲", code: "CM", dialCode: "+237" },
  { value: "Angola", label: "Angola", flag: "🇦🇴", code: "AO", dialCode: "+244" },
  { value: "Mozambique", label: "Mozambique", flag: "🇲🇿", code: "MZ", dialCode: "+258" },
  { value: "Zimbabwe", label: "Zimbabwe", flag: "🇿🇼", code: "ZW", dialCode: "+263" },
  { value: "Zambia", label: "Zambia", flag: "🇿🇲", code: "ZM", dialCode: "+260" },
  { value: "Botswana", label: "Botswana", flag: "🇧🇼", code: "BW", dialCode: "+267" },
  { value: "Namibia", label: "Namibia", flag: "🇳🇦", code: "NA", dialCode: "+264" },
  { value: "Rwanda", label: "Rwanda", flag: "🇷🇼", code: "RW", dialCode: "+250" },
  { value: "Madagascar", label: "Madagascar", flag: "🇲🇬", code: "MG", dialCode: "+261" },
  { value: "Mauritius", label: "Mauritius", flag: "🇲🇺", code: "MU", dialCode: "+230" },
  { value: "Seychelles", label: "Seychelles", flag: "🇸🇨", code: "SC", dialCode: "+248" },
  { value: "Mali", label: "Mali", flag: "🇲🇱", code: "ML", dialCode: "+223" },
  { value: "Burkina Faso", label: "Burkina Faso", flag: "🇧🇫", code: "BF", dialCode: "+226" },
  { value: "Niger", label: "Niger", flag: "🇳🇪", code: "NE", dialCode: "+227" },
  { value: "Chad", label: "Chad", flag: "🇹🇩", code: "TD", dialCode: "+235" },
  { value: "Benin", label: "Benin", flag: "🇧🇯", code: "BJ", dialCode: "+229" },
  { value: "Togo", label: "Togo", flag: "🇹🇬", code: "TG", dialCode: "+228" },
  { value: "Guinea", label: "Guinea", flag: "🇬🇳", code: "GN", dialCode: "+224" },
  { value: "Sierra Leone", label: "Sierra Leone", flag: "🇸🇱", code: "SL", dialCode: "+232" },
  { value: "Liberia", label: "Liberia", flag: "🇱🇷", code: "LR", dialCode: "+231" },
  { value: "Gabon", label: "Gabon", flag: "🇬🇦", code: "GA", dialCode: "+241" },
  { value: "Congo", label: "Congo", flag: "🇨🇬", code: "CG", dialCode: "+242" },
  { value: "Democratic Republic of Congo", label: "Democratic Republic of Congo", flag: "🇨🇩", code: "CD", dialCode: "+243" },
  { value: "Malawi", label: "Malawi", flag: "🇲🇼", code: "MW", dialCode: "+265" },
  { value: "Lesotho", label: "Lesotho", flag: "🇱🇸", code: "LS", dialCode: "+266" },
  { value: "Eswatini", label: "Eswatini", flag: "🇸🇿", code: "SZ", dialCode: "+268" },
  
  // East & Southeast Asia
  { value: "China", label: "China", flag: "🇨🇳", code: "CN", dialCode: "+86" },
  { value: "Japan", label: "Japan", flag: "🇯🇵", code: "JP", dialCode: "+81" },
  { value: "South Korea", label: "South Korea", flag: "🇰🇷", code: "KR", dialCode: "+82" },
  { value: "North Korea", label: "North Korea", flag: "🇰🇵", code: "KP", dialCode: "+850" },
  { value: "Taiwan", label: "Taiwan", flag: "🇹🇼", code: "TW", dialCode: "+886" },
  { value: "Hong Kong", label: "Hong Kong", flag: "🇭🇰", code: "HK", dialCode: "+852" },
  { value: "Macau", label: "Macau", flag: "🇲🇴", code: "MO", dialCode: "+853" },
  { value: "Mongolia", label: "Mongolia", flag: "🇲🇳", code: "MN", dialCode: "+976" },
  { value: "Singapore", label: "Singapore", flag: "🇸🇬", code: "SG", dialCode: "+65" },
  { value: "Thailand", label: "Thailand", flag: "🇹🇭", code: "TH", dialCode: "+66" },
  { value: "Vietnam", label: "Vietnam", flag: "🇻🇳", code: "VN", dialCode: "+84" },
  { value: "Malaysia", label: "Malaysia", flag: "🇲🇾", code: "MY", dialCode: "+60" },
  { value: "Indonesia", label: "Indonesia", flag: "🇮🇩", code: "ID", dialCode: "+62" },
  { value: "Philippines", label: "Philippines", flag: "🇵🇭", code: "PH", dialCode: "+63" },
  { value: "Brunei", label: "Brunei", flag: "🇧🇳", code: "BN", dialCode: "+673" },
  { value: "Myanmar", label: "Myanmar", flag: "🇲🇲", code: "MM", dialCode: "+95" },
  { value: "Cambodia", label: "Cambodia", flag: "🇰🇭", code: "KH", dialCode: "+855" },
  { value: "Laos", label: "Laos", flag: "🇱🇦", code: "LA", dialCode: "+856" },
  { value: "Timor-Leste", label: "Timor-Leste", flag: "🇹🇱", code: "TL", dialCode: "+670" },
  
  // South Asia
  { value: "India", label: "India", flag: "🇮🇳", code: "IN", dialCode: "+91" },
  { value: "Pakistan", label: "Pakistan", flag: "🇵🇰", code: "PK", dialCode: "+92" },
  { value: "Bangladesh", label: "Bangladesh", flag: "🇧🇩", code: "BD", dialCode: "+880" },
  { value: "Sri Lanka", label: "Sri Lanka", flag: "🇱🇰", code: "LK", dialCode: "+94" },
  { value: "Nepal", label: "Nepal", flag: "🇳🇵", code: "NP", dialCode: "+977" },
  { value: "Bhutan", label: "Bhutan", flag: "🇧🇹", code: "BT", dialCode: "+975" },
  { value: "Maldives", label: "Maldives", flag: "🇲🇻", code: "MV", dialCode: "+960" },
  { value: "Afghanistan", label: "Afghanistan", flag: "🇦🇫", code: "AF", dialCode: "+93" },
  
  // Latin America & Caribbean
  { value: "Brazil", label: "Brazil", flag: "🇧🇷", code: "BR", dialCode: "+55" },
  { value: "Mexico", label: "Mexico", flag: "🇲🇽", code: "MX", dialCode: "+52" },
  { value: "Argentina", label: "Argentina", flag: "🇦🇷", code: "AR", dialCode: "+54" },
  { value: "Chile", label: "Chile", flag: "🇨🇱", code: "CL", dialCode: "+56" },
  { value: "Colombia", label: "Colombia", flag: "🇨🇴", code: "CO", dialCode: "+57" },
  { value: "Peru", label: "Peru", flag: "🇵🇪", code: "PE", dialCode: "+51" },
  { value: "Venezuela", label: "Venezuela", flag: "🇻🇪", code: "VE", dialCode: "+58" },
  { value: "Ecuador", label: "Ecuador", flag: "🇪🇨", code: "EC", dialCode: "+593" },
  { value: "Bolivia", label: "Bolivia", flag: "🇧🇴", code: "BO", dialCode: "+591" },
  { value: "Paraguay", label: "Paraguay", flag: "🇵🇾", code: "PY", dialCode: "+595" },
  { value: "Uruguay", label: "Uruguay", flag: "🇺🇾", code: "UY", dialCode: "+598" },
  { value: "Guyana", label: "Guyana", flag: "🇬🇾", code: "GY", dialCode: "+592" },
  { value: "Suriname", label: "Suriname", flag: "🇸🇷", code: "SR", dialCode: "+597" },
  { value: "French Guiana", label: "French Guiana", flag: "🇬🇫", code: "GF", dialCode: "+594" },
  
  // Central America
  { value: "Costa Rica", label: "Costa Rica", flag: "🇨🇷", code: "CR", dialCode: "+506" },
  { value: "Panama", label: "Panama", flag: "🇵🇦", code: "PA", dialCode: "+507" },
  { value: "Guatemala", label: "Guatemala", flag: "🇬🇹", code: "GT", dialCode: "+502" },
  { value: "Honduras", label: "Honduras", flag: "🇭🇳", code: "HN", dialCode: "+504" },
  { value: "El Salvador", label: "El Salvador", flag: "🇸🇻", code: "SV", dialCode: "+503" },
  { value: "Nicaragua", label: "Nicaragua", flag: "🇳🇮", code: "NI", dialCode: "+505" },
  { value: "Belize", label: "Belize", flag: "🇧🇿", code: "BZ", dialCode: "+501" },
  
  // Caribbean
  { value: "Cuba", label: "Cuba", flag: "🇨🇺", code: "CU", dialCode: "+53" },
  { value: "Jamaica", label: "Jamaica", flag: "🇯🇲", code: "JM", dialCode: "+1876" },
  { value: "Haiti", label: "Haiti", flag: "🇭🇹", code: "HT", dialCode: "+509" },
  { value: "Dominican Republic", label: "Dominican Republic", flag: "🇩🇴", code: "DO", dialCode: "+1809" },
  { value: "Puerto Rico", label: "Puerto Rico", flag: "🇵🇷", code: "PR", dialCode: "+1787" },
  { value: "Trinidad and Tobago", label: "Trinidad and Tobago", flag: "🇹🇹", code: "TT", dialCode: "+1868" },
  { value: "Barbados", label: "Barbados", flag: "🇧🇧", code: "BB", dialCode: "+1246" },
  { value: "Bahamas", label: "Bahamas", flag: "🇧🇸", code: "BS", dialCode: "+1242" },
  { value: "Grenada", label: "Grenada", flag: "🇬🇩", code: "GD", dialCode: "+1473" },
  { value: "Saint Lucia", label: "Saint Lucia", flag: "🇱🇨", code: "LC", dialCode: "+1758" },
  { value: "Saint Vincent and the Grenadines", label: "Saint Vincent and the Grenadines", flag: "🇻🇨", code: "VC", dialCode: "+1784" },
  { value: "Antigua and Barbuda", label: "Antigua and Barbuda", flag: "🇦🇬", code: "AG", dialCode: "+1268" },
  { value: "Dominica", label: "Dominica", flag: "🇩🇲", code: "DM", dialCode: "+1767" },
  { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis", flag: "🇰🇳", code: "KN", dialCode: "+1869" },
  
  // Pacific Islands
  { value: "Fiji", label: "Fiji", flag: "🇫🇯", code: "FJ", dialCode: "+679" },
  { value: "Papua New Guinea", label: "Papua New Guinea", flag: "🇵🇬", code: "PG", dialCode: "+675" },
  { value: "Samoa", label: "Samoa", flag: "🇼🇸", code: "WS", dialCode: "+685" },
  { value: "Tonga", label: "Tonga", flag: "🇹🇴", code: "TO", dialCode: "+676" },
  { value: "Vanuatu", label: "Vanuatu", flag: "🇻🇺", code: "VU", dialCode: "+678" },
  { value: "Solomon Islands", label: "Solomon Islands", flag: "🇸🇧", code: "SB", dialCode: "+677" },
  { value: "Micronesia", label: "Micronesia", flag: "🇫🇲", code: "FM", dialCode: "+691" },
  { value: "Palau", label: "Palau", flag: "🇵🇼", code: "PW", dialCode: "+680" },
  { value: "Marshall Islands", label: "Marshall Islands", flag: "🇲🇭", code: "MH", dialCode: "+692" },
  { value: "Kiribati", label: "Kiribati", flag: "🇰🇮", code: "KI", dialCode: "+686" },
  { value: "Tuvalu", label: "Tuvalu", flag: "🇹🇻", code: "TV", dialCode: "+688" },
  { value: "Nauru", label: "Nauru", flag: "🇳🇷", code: "NR", dialCode: "+674" },
].sort((a, b) => a.label.localeCompare(b.label));

/**
 * Helper function to find a country by its code
 */
export function getCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find(c => c.code === code);
}

/**
 * Helper function to find a country by its name/value
 */
export function getCountryByName(name: string): Country | undefined {
  return COUNTRIES.find(c => c.value === name || c.label === name);
}

/**
 * Helper function to get all country codes
 */
export function getCountryCodes(): string[] {
  return COUNTRIES.map(c => c.code);
}
